import React from 'react';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import { userService } from './../../services/user.service';
import CommonMessage from './../common/commonMessage';
import Validate from './../common/validate';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import Axios from 'axios';
import { Redirect } from 'react-router-dom';
import { AuditLog } from './../../services/auditlog.service';
import { ResourceService } from './../../services/resource.service';
import { API_HOST, axiosRequestWithAuth, axiosInstance } from './../../constants/server.constant';
import NotificationSlider from '../common/topRightHeader/notificationSlider';

class User extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            userCount: 0,
            enableuseroptions: false,
            enableadduser: false,
            enableedituser: false,
            enabledeleteuser: false,
            editFirstName: "",
            editLastName: "",
            username: "",
            email: "",
            nametoggle: false,
            mailtoggle: false,
            datetoggle: false,
            roletoggle: false,
            statustoggle: false,
            usernametoggle: true,
            twoFAToggle: false,
            userId: "",
            usernameRegex: false,
            firstNameRegex: false,
            lastNameRegex: false,
            emailRegex: false,
            isAction: false,
            deleteEmail: "",
            addusernameempty: false,
            addemailempty: false,
            addusername: "",
            addemail: "",
            usernameexists: false,
            getEditButton: false,
            count: 0,
            isAddUser: false,
            deleteUserStatus: "",
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            addEnableStatus: "DISABLE",
            isEnablePopUp: false,
            isDisablePopUp: false,
            isResetPopUp: false,
            currentUser: "",
            paginationCount: 50,
            indexCount: 0,
            pagedUserList: [],
            enableCancelledUsers: false,
            cancelledUsersCount: 0,
            cancelledUsers: [],
            pagedCancelledUser: [],
            cancelUser: false,
            cancelEmailToggle: false,
            cancelFnameToggle: true,
            cancelLnameToggle: true,
            reactivateId: "",
            reactivateEmail: "",
            disableResendBtn: false
        };

        this.emailInput = React.createRef();
        this.editfirstnameinput = React.createRef();
        this.editlastnameinput = React.createRef();
        this.editemailinput = React.createRef();
        this.usernamefocus = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.enableUserOptions = this.enableUserOptions.bind(this);
        this.enableAddUser = this.enableAddUser.bind(this);
        this.enableEditUser = this.enableEditUser.bind(this);
        this.enableDeleteUser = this.enableDeleteUser.bind(this);
        this.addUser = this.addUser.bind(this);
        this.editUser = this.editUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.handleInputs = this.handleInputs.bind(this);
        this.getEditFocus = this.getEditFocus.bind(this);
        this.closeslider = this.closeslider.bind(this);
        this.enableCheckBox = this.enableCheckBox.bind(this);
        this.enterPressed = this.enterPressed.bind(this);
        this.escfunction = this.escfunction.bind(this);

    };
    enterPressed(event, param) {
        var code = event.keyCode || event.which;
        if(code === 13 && param === "add") {
            if(!this.state.isAddUser) {
                this.addUser();
            }

        }

    }
    closeslider = (param) => {
        if(param === "editslider") {
            $(".edit_user_slider").removeClass("active");
        }
        if(param === "addslider") {
            $(".add_user_slider").removeClass("active");
        }
        if(param === "delete") {
            $(".delete_user_popup").removeClass("active");
            $(".delete_cancelled_user_popup").removeClass("active");
            $("body").removeClass("popup_no_scroll");
        }
        if(param === "reactivate") {
            $(".confirm_reactivate").removeClass("active");
            $("body").removeClass("popup_no_scroll");
        }
    };

    getEditFocus = (param) => {
        if(param === "addemail") {
            if(this.state.addusername.length <= 0) {
                this.setState({
                    addusernameempty: true
                });
            }
            else {
                this.setState({
                    addusernameempty: false
                });
            }
        }
        else if(param === "lastname") {
            if(this.state.editFirstName.length <= 0) {
                this.setState({
                    editfirstnameempty: true
                });
            }
            else {
                this.setState({
                    editfirstnameempty: false
                });
            }
        }
        else if(param === "email") {
            if(this.state.editFirstName.length <= 0) {
                this.setState({
                    editfirstnameempty: true
                });
            }
            if(this.state.editLastName.length <= 0) {
                this.setState({
                    editlastnameempty: true
                });
            }
            if(this.state.editFirstName.length > 0) {
                this.setState({
                    editfirstnameempty: false
                });
            }
            if(this.state.editLastName.length > 0) {
                this.setState({
                    editlastnameempty: false
                });
            }
        }
    };


    componentWillMount() {
        //this.loadcss();
        document.removeEventListener("keyup", this.escfunction, false);
    }
    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                isEnablePopUp: false,
                isDisablePopUp: false
            });

        }
    }

    componentDidMount() {
        this.setState({
            isAction: true,

        });
        document.addEventListener("keyup", this.escfunction, false);
        this.checkForSubscription();
    }

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details",
                    msgType: "error"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
            }
            else {
                this.setState({
                    isUserSubscribed: false
                });
                this.getAllUsers();
            }

        });
    };

    loadcss = () => {
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/webapp/css/users.css";
        link.rel = "stylesheet";
        link.type = "text/css";
        document
            .head
            .appendChild(link);
    };

    getAllUsers = () => {

        userService.getAllUsersById().then((resp) => {
            if(resp === false) {
                this.setState({
                    message: "Error while fetching user Details, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }

            let userList = resp.data.body.userMapping;
            let userListArr = [];
            let cancelledUserArr = [];
            for(let i = 0; i < userList.length; i++) {
                if(userList[i].user_slave_id.status === 'Y' || userList[i].user_slave_id.status === 'N' || userList[i].user_slave_id.status === 'S') {
                    let d = new Date(userList[i].user_slave_id.createdOn);
                    var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                    let createdDate = d.toLocaleString("en", options);
                    //let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() +' '+(d.getUTCHours()<10?'0':'')+d.getUTCHours()+':'+(d.getUTCMinutes()<10?'0':'')+d.getUTCMinutes();
                    let obj = {
                        id: userList[i].user_slave_id.id,
                        username: userList[i].user_slave_id.username,
                        name: userList[i].user_slave_id.firstName.length > 0 ? userList[i].user_slave_id.firstName + " " + userList[i].user_slave_id.lastName : "----",
                        firstname: userList[i].user_slave_id.firstName,
                        lastname: userList[i].user_slave_id.lastName,
                        email: userList[i].user_slave_id.email,
                        createdOn: createdDate,
                        role: "Member",
                        status: userList[i].user_slave_id.status === 'Y' || userList[i].user_slave_id.status === 'S' ? "Active" : "Invited",
                        authStatus: userList[i].is_2fa_enabled == "0" ? "2FA Disabled" : userList[i].auth_type == "0" ? "Configuration Pending" : "Configured",
                        authClass: userList[i].is_2fa_enabled == "0" ? "twofaDisabled" : userList[i].auth_type == "0" ? "configPending" : "configured",
                    };
                    userListArr.push(obj);
                }
                else if(userList[i].user_slave_id.status === 'C') {
                    let d = new Date(userList[i].user_slave_id.createdOn);
                    var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                    let createdDate = d.toLocaleString("en", options);
                    //let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() +' '+(d.getUTCHours()<10?'0':'')+d.getUTCHours()+':'+(d.getUTCMinutes()<10?'0':'')+d.getUTCMinutes();
                    let obj = {
                        id: userList[i].user_slave_id.id,
                        username: userList[i].user_slave_id.username,
                        name: userList[i].user_slave_id.firstName.length > 0 ? userList[i].user_slave_id.firstName + " " + userList[i].user_slave_id.lastName : "----",
                        firstname: userList[i].user_slave_id.firstName,
                        lastname: userList[i].user_slave_id.lastName,
                        email: userList[i].user_slave_id.email,
                        createdOn: createdDate,
                        role: "Member",
                        status: userList[i].user_slave_id.status,
                        authStatus: userList[i].is_2fa_enabled == "0" ? "2FA Disabled" : userList[i].auth_type == "0" ? "Configuration Pending" : "Configured",
                        authClass: userList[i].is_2fa_enabled == "0" ? "twofaDisabled" : userList[i].auth_type == "0" ? "configPending" : "configured",
                    };
                    cancelledUserArr.push(obj);
                }
            }

            let items = [...userListArr];

            items.sort(function (a, b) {
                if(a.email < b.email) { return -1; }
                if(a.email > b.email) { return 1; }
                return 0;
            });

            let cancelItems = [...cancelledUserArr];

            cancelItems.sort(function (a, b) {
                if(a.email < b.email) { return -1; }
                if(a.email > b.email) { return 1; }
                return 0;
            });

            let pagedUserList = [...items];
            if(pagedUserList.length > this.state.paginationCount) pagedUserList = pagedUserList.slice(0, this.state.paginationCount);

            let pagedCancelUserList = [...cancelItems];
            if(pagedCancelUserList.length > this.state.paginationCount) pagedCancelUserList = pagedCancelUserList.slice(0, this.state.paginationCount);

            this.setState({
                users: items,
                cancelledUsers: cancelItems,
                userCount: userListArr.length,
                isAction: false,
                pagedUserList: pagedUserList,
                pagedCancelledUser: pagedCancelUserList,
                indexCount: 0
            }, () => this.activateActionMenu());
            if(resp.data.body.status === "S") {
                this.setState({
                    disableResendBtn: true
                });
            }
            this.getAdmin2FAStatus();
        }).catch(err => {
            this.setState({
                isAction: false,
                message: "Error while getting users, Please try after sometime.",
                msgType: "error"
            });
        });
    };

    getAdmin2FAStatus = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/user/getadmin2fainfo/" + userId, axiosRequestWithAuth).then(resp => {
            this.setState({
                isAction: false
            });
            let admin = resp.data.body;
            this.setState({
                adminStatus: admin.adminStatus
            });
            if(this.state.adminStatus === "ENABLED") {
                this.setState({
                    addEnableStatus: "ENABLE"
                });
            }
            else {
                this.setState({
                    addEnableStatus: "DISABLE"
                });
            }
        }).catch(error => {
            this.setState({
                isAction: false
            });
        });
    };

    activateActionMenu() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {
            $('.tabular_data_wrap .table_data .tr').removeClass('active');
            $(this).closest('.tr').addClass('active');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('active');
            $(this).find('.dropdown_component').css({ top: '30px' });
            var fmi = 'dropdown_component';
            var offset = $(this).offset();
            //var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');
            }
            else if(documentwindowHeight > totalHeight) {
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }
        });
    }


    enableUserOptions = (event, param) => {
        event.preventDefault();
        $(event.currentTarget).closest('.tr').find('.users_row_options').toggleClass('active');
        this.setState({
            username: param
        });
    };

    enableAddUser = () => {
        $(".add_user_slider").addClass("active");
        this.setState({
            addusername: "",
            addemail: "",
            usernameRegex: false,
            usernameexists: false,
            emailRegex: false,
            addusernameempty: false,
            addemailempty: false
        });
        document.getElementById("enableCheckBox").checked = false;
        setTimeout(() => {
            this.emailInput.current.focus();
        }, 100);

    };

    enableEditUser = (param) => {
        $(".edit_user_slider").addClass("active");

        this.setState({
            getEditButton: false,
            editfirstnameempty: false,
            editlastnameempty: false,
            editemailempty: false,
            firstNameRegex: false,
            lastNameRegex: false,
            emailRegex: false,
            message: "",
            email: param[0],
            userId: param[1],
            editFirstName: param[2],
            editLastName: param[3],
            defaultEditFirstName: param[2],
            defaultEditLastName: param[3],
            defaultEditEmail: param[0]
        });
        setTimeout(() => {
            this.editfirstnameinput.current.focus();
        }, 100);

    };

    enableDeleteUser = (param) => {

        this.setState({
            message: "",
            userId: param[0],
            deleteEmail: param[1],
            deleteUserStatus: param[2],
            cancelUser: param[3] === "cancel" ? true : false
        });
        if(param[3] === "cancel") {
            $(".delete_cancelled_user_popup").addClass("active");
        }
        else {
            $(".delete_user_popup").addClass("active");
        }


        $("body").addClass("popup_no_scroll");

        document.getElementById("deleteUser").focus();

    };

    enableUserReactivate = (user) => {
        this.setState({
            message: "",
            reactivateId: user.id,
            reactivateEmail: user.email
        });

        $(".confirm_reactivate").addClass("active");

        $("body").addClass("popup_no_scroll");

        document.getElementById("reactivateUser").focus();
    };

    addUser = () => {
        if(this.state.addemail.length <= 0) {
            this.setState({
                addemailempty: true
            });
            this.emailInput.current.focus();
        }
        else if(!Validate("email", this.state.addemail)) {
            this.setState({
                emailRegex: true
            });
            this.emailInput.current.focus();
            return;
        }
        else {
            if(this.state.isUserSubscribed) {
                this.setState({
                    isRedirectToCCPage: true
                });
            }
            else {

                this.setState({
                    enableadduser: false,
                    isAction: true,
                    isAddUser: true
                });

                const requestBody =
                    JSON.stringify({
                        companyName: "",
                        countryCode: "",
                        email: this.state.addemail,
                        firstName: "",
                        lastName: "",
                        password: "",
                        phone: "",
                        status: 'N'
                    });


                let usernameToLog = this.state.addemail;
                userService.addUser(requestBody, this.state.addEnableStatus).then((resp) => {
                    if(resp === false) {
                        this.setState({
                            message: "Failed to add Member, Try again!",
                            msgType: "error",
                            addusername: "",
                            addaemail: "",
                            isAction: false,
                            usernameRegex: false,
                            addusernameempty: false,
                            emailRegex: false,
                            addemailempty: false,
                            usernameexists: false,
                            isAddUser: false
                        });
                        $(".add_user_slider").removeClass("active");
                        return;
                    }
                    if(resp.data.error) {
                        if(resp.data.message == "Email Blocked") {
                            this.setState({
                                enableadduser: true,
                                usernameexists: false,
                                isAction: false,
                                isAddUser: false,
                                emailRegex: true
                            });
                            return;
                        }
                        this.setState({
                            enableadduser: true,
                            usernameexists: true,
                            isAction: false,
                            isAddUser: false,
                            emailRegex: false
                        });
                        return;
                    }
                    const userAdd = {
                        "userId": localStorage.getItem("userId"),
                        "name": usernameToLog + " has been added",
                        "operation": "User Added",
                        "details": "User " + usernameToLog + " has been added"
                    };
                    AuditLog.storeAuditLogs(userAdd, "web").then((resp) => {
                        if(resp === false);
                    });
                    this.setState({
                        message: "User has been added successfully",
                        msgType: "success",
                        addusername: "",
                        addemail: "",
                        usernameRegex: false,
                        addusernameempty: false,
                        emailRegex: false,
                        addemailempty: false,
                        usernameexists: false,
                        isAddUser: false
                    });
                    $(".add_user_slider").removeClass("active");
                    this.getAllUsers();
                }).catch(err => {
                    this.setState({
                        message: err?.response?.data,
                        msgType: "error",
                        addusername: "",
                        addaemail: "",
                        isAction: false,
                        usernameRegex: false,
                        addusernameempty: false,
                        emailRegex: false,
                        addemailempty: false,
                        usernameexists: false,
                        isAddUser: false
                    });
                    $(".add_user_slider").removeClass("active");
                    return;
                });
            }

        }

    };

    deleteUser = () => {
        $(".delete_user_popup").removeClass("active");
        $(".delete_cancelled_user_popup").removeClass("active");
        $("body").removeClass("popup_no_scroll");
        if(this.state.enableCancelledUsers) {
            this.deleteCancelledUser();
            return;
        }
        this.setState({
            isAction: true
        });
        userService.deleteUser(this.state.userId).then((resp) => {
            if(resp === false) {
                this.setState({
                    message: "Failed to delete Member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            if(resp.data.error) {
                this.setState({
                    message: "Failed to delete Member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            this.setState({
                message: "User has been deleted successfully",
                msgType: "success",
                isAction: false
            });
            this.getAllUsers();
        });
    };

    editUser = () => {

        if(this.state.editFirstName.length <= 0) {
            this.setState({
                editfirstnameempty: true
            });
            this.editfirstnameinput.current.focus();
            return;
        }
        else if(this.state.editLastName.length <= 0) {
            this.setState({
                editlastnameempty: true
            });
            this.editlastnameinput.current.focus();
            return;
        }
        else if(this.state.email.length <= 0) {
            this.setState({
                editemailempty: true
            });
            this.editemailinput.current.focus();
            return;
        }

        else if(!Validate("firstName", this.state.editFirstName)) {
            this.setState({
                firstNameRegex: true
            });
            this.editfirstnameinput.current.focus();
            return;
        }
        else if(!Validate("lastName", this.state.editLastName)) {
            this.setState({
                lastNameRegex: true
            });
            this.editlastnameinput.current.focus();
            return;
        }
        else if(!Validate("email", this.state.email)) {
            this.setState({
                emailRegex: true
            });
            this.editemailinput.current.focus();
            return;
        }
        else if(this.state.defaultEditFirstName === this.state.editFirstName &&
            this.state.defaultEditLastName === this.state.editLastName &&
            this.state.defaultEditEmail === this.state.email) {
            this.setState({
                message: "No changes found to update the profile",
                msgType: "error"
            });
            return false;
        }
        else {
            this.setState({
                isAction: true
            });
            let usernameEdit = this.state.email;
            userService.editUser(this.state.userId, this.state.email, this.state.editFirstName, this.state.editLastName).then((resp) => {
                if(resp === false) {
                    this.setState({
                        message: "Failed to edit Member, Try again!",
                        msgType: "error",
                        isAction: false
                    });
                    return;
                }
                const userAdd = {
                    "userId": localStorage.getItem("userId"),
                    "name": usernameEdit + " has been modified",
                    "operation": "User Added",
                    "details": "User " + usernameEdit + " details has been modified"
                };
                AuditLog.storeAuditLogs(userAdd, "web").then((resp) => {
                    if(resp === false);
                });
                this.setState({
                    message: "User details have been updated",
                    msgType: "success",
                    enableedituser: false
                });
                $(".edit_user_slider").removeClass("active");
                this.getAllUsers();
            });
        }

    };

    handleInputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            [name]: val,
            getEditButton: true
        });
        if(name === "addusername") {
            this.setState({
                usernameexists: false,
                usernameRegex: false
            });
            if(val.length <= 0) {
                this.setState({
                    addusernameempty: true
                });
            }
            else {
                this.setState({
                    addusernameempty: false
                });
            }
        }
        if(name === "addemail") {
            this.setState({
                emailRegex: false
            });
            if(val.length <= 0) {
                this.setState({
                    addemailempty: true
                });
            }
            else {
                this.setState({
                    addemailempty: false
                });
            }
        }

        if(name === "editFirstName") {
            this.setState({
                firstNameRegex: false
            });
            if(val.length <= 0) {
                this.setState({
                    editfirstnameempty: true
                });
            }
            else {
                this.setState({
                    editfirstnameempty: false
                });
            }

        }
        if(name === "editLastName") {
            this.setState({
                lastNameRegex: false
            });
            if(val.length <= 0) {
                this.setState({
                    editlastnameempty: true
                });
            }
            else {
                this.setState({
                    editlastnameempty: false
                });
            }

        }

        if(name === "email") {
            this.setState({
                emailRegex: false
            });
            if(val.length <= 0) {
                this.setState({
                    editemailempty: true
                });
            }
            else {
                this.setState({
                    editemailempty: false
                });
            }

        }

    };

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };
    setSortingForCancelUser = (param) => {
        let items = [...this.state.cancelledUsers];
        if(param === "mail") {
            if(this.state.cancelEmailToggle) {
                items.sort(function (a, b) {
                    if(a.email < b.email) { return -1; }
                    if(a.email > b.email) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.email < b.email) { return 1; }
                    if(a.email > b.email) { return -1; }
                    return 0;
                });

            }
            this.setState({
                cancelEmailToggle: !this.state.cancelEmailToggle,
                cancelFnameToggle: false,
                cancelLnameToggle: false
            });
        }

        else if(param === "fname") {
            if(this.state.cancelFnameToggle) {
                items.sort(function (a, b) {
                    if(a.firstname < b.firstname) { return -1; }
                    if(a.firstname > b.firstname) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.firstname < b.firstname) { return 1; }
                    if(a.firstname > b.firstname) { return -1; }
                    return 0;
                });

            }
            this.setState({
                cancelEmailToggle: false,
                cancelFnameToggle: !this.state.cancelFnameToggle,
                cancelLnameToggle: false
            });
        }

        else if(param === "lname") {
            if(this.state.cancelLnameToggle) {
                items.sort(function (a, b) {
                    if(a.lastname < b.lastname) { return -1; }
                    if(a.lastname > b.lastname) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.lastname < b.lastname) { return 1; }
                    if(a.lastname > b.lastname) { return -1; }
                    return 0;
                });

            }
            this.setState({
                cancelEmailToggle: false,
                cancelFnameToggle: false,
                cancelLnameToggle: !this.state.cancelLnameToggle
            });
        }

        let pagedCancelUserList = [...items];
        if(pagedCancelUserList.length > this.state.paginationCount) pagedCancelUserList = pagedCancelUserList.slice(0, this.state.paginationCount);
        this.setState({
            cancelledUsers: items,
            pagedCancelledUser: pagedCancelUserList,
            indexCount: 0
        });
    };
    setSortable = (param) => {

        let items = [...this.state.users];
        if(param[0] === "name") {
            if(this.state.nametoggle) {
                items.sort(function (a, b) {
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.name < b.name) { return 1; }
                    if(a.name > b.name) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //users: items,
                nametoggle: !this.state.nametoggle,
                mailtoggle: false,
                datetoggle: false,
                roletoggle: false,
                statustoggle: false,
                usernametoggle: false,
                twoFAToggle: false
            });

        }

        else if(param[0] === "mail") {
            if(this.state.mailtoggle) {
                items.sort(function (a, b) {
                    if(a.email < b.email) { return -1; }
                    if(a.email > b.email) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.email < b.email) { return 1; }
                    if(a.email > b.email) { return -1; }
                    return 0;
                });

            }
            this.setState({
                // users: items,
                mailtoggle: !this.state.mailtoggle,
                nametoggle: false,
                datetoggle: false,
                roletoggle: false,
                statustoggle: false,
                usernametoggle: false,
                twoFAToggle: false
            });

        }
        else if(param[0] === "date") {
            if(this.state.datetoggle) {
                items.sort(function (a, b) {
                    return new Date(a.createdOn) - new Date(b.createdOn);
                });

            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.createdOn) - new Date(a.createdOn);
                });

            }
            this.setState({
                // users: items,
                datetoggle: !this.state.datetoggle,
                nametoggle: false,
                mailtoggle: false,
                roletoggle: false,
                statustoggle: false,
                usernametoggle: false,
                twoFAToggle: false
            });

        }
        else if(param[0] === "role") {
            if(this.state.roletoggle) {
                items.sort(function (a, b) {
                    if(a.role < b.role) { return -1; }
                    if(a.role > b.role) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.role < b.role) { return 1; }
                    if(a.role > b.role) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //users: items,
                roletoggle: !this.state.roletoggle,
                nametoggle: false,
                mailtoggle: false,
                datetoggle: false,
                statustoggle: false,
                usernametoggle: false,
                twoFAToggle: false
            });

        }
        else if(param[0] === "status") {
            if(this.state.statustoggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //users: items,
                statustoggle: !this.state.statustoggle,
                nametoggle: false,
                mailtoggle: false,
                datetoggle: false,
                roletoggle: false,
                usernametoggle: false,
                twoFAToggle: false
            });

        }
        else if(param[0] === "2fa") {
            if(this.state.twoFAToggle) {
                items.sort(function (a, b) {
                    if(a.authStatus < b.authStatus) { return -1; }
                    if(a.authStatus > b.authStatus) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.authStatus < b.authStatus) { return 1; }
                    if(a.authStatus > b.authStatus) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //users: items,
                twoFAToggle: !this.state.twoFAToggle,
                statustoggle: false,
                nametoggle: false,
                mailtoggle: false,
                datetoggle: false,
                roletoggle: false,
                usernametoggle: false,
            });
        }
        let pagedUserList = [...items];
        if(pagedUserList.length > this.state.paginationCount) pagedUserList = pagedUserList.slice(0, this.state.paginationCount);

        this.setState({
            users: items,
            pagedUserList: pagedUserList,
            indexCount: 0
        });
    };

    do2faoperation = (user, type) => {
        this.setState({
            isAction: true,
            isEnablePopUp: false,
            isDisablePopUp: false
        });

        let userId = localStorage.getItem("userId");
        let opera = "";
        if(type === "ENABLE") {
            opera = "enabled";
        }
        else if(type === "DISABLE") {
            opera = "disabled";
        }
        else {
            opera = "reset";
        }
        axiosInstance.post(API_HOST + "/user/authoperation/" + type + "/" + user.id + "/" + userId, null, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data.body;
                if(resp === "UPDATED") {
                    this.setState({
                        message: "Two-factor authentication has been " + opera + " for " + user.email,
                        msgType: "success"
                    });
                }
                else {
                    this.setState({
                        message: "Two-factor authentication cannot be updated",
                        msgType: "error"
                    });
                }
                this.setState({
                    isAction: false
                });

                this.getAllUsers();
            }).catch(error => {
                this.setState({
                    isAction: false,
                    message: "Error while updating 2FA status",
                    msgType: "error"
                });
            });
    };

    enableCheckBox = (event) => {

        // let val = event.target.checked;

        if(this.state.adminStatus === "ENABLED") {
            this.setState({
                addEnableStatus: "ENABLE"
            });
        }
        else {
            this.setState({
                addEnableStatus: "DISABLE"
            });
        }
    };

    resendActivationEmail = (event, user) => {
        this.setState({ isAction: true });
        let userId = localStorage.getItem("userId");

        axiosInstance.post(API_HOST + "/user/resendactivationemail/" + userId + "?subUserId=" + user.id, {}, axiosRequestWithAuth)
            .then(resp => {
                let res = resp.data;
                if(res.body === "USER_SUSPENDED") {
                    this.setState({
                        isAction: false,
                        message: "Your account has been suspended due to non payment. Please update yout payment information and clear any dues to send user invite",
                        msgType: "error"
                    });
                    return;
                }
                if(res.body === "EMAIL_SENT") {
                    this.setState({
                        isAction: false,
                        message: "Account activation email has been sent to " + user.email,
                        msgType: ""
                    });
                    return;
                }
                this.setState({
                    isAction: false,
                    message: "Error while sending email",
                    msgType: "error"
                });
            })
            .catch(error => {
                console.log(JSON.stringify(error));
                this.setState({
                    isAction: false,
                    message: "Error while sending email",
                    msgType: "error"
                });
            });
    };

    handleNextClick = (event) => {
        let users = [...this.state.users];
        let indexCount = this.state.indexCount + this.state.paginationCount;
        let endCount = indexCount + this.state.paginationCount;
        if(endCount > users.length) endCount = users.length;
        this.setState({
            indexCount: indexCount,
            pagedUserList: users.slice(indexCount, endCount),
            pagedCancelledUser: users.slice(indexCount, endCount),
        });
        event.preventDefault();
    };

    handleCancelNextClick = (event) => {
        let users = [...this.state.cancelledUsers];
        let indexCount = this.state.indexCount + this.state.paginationCount;
        let endCount = indexCount + this.state.paginationCount;
        if(endCount > users.length) endCount = users.length;
        this.setState({
            indexCount: indexCount,
            pagedCancelledUser: users.slice(indexCount, endCount),
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let users = [...this.state.users];
        let indexCount = this.state.indexCount - this.state.paginationCount;
        this.setState({
            indexCount: this.state.indexCount - this.state.paginationCount,
            pagedUserList: users.slice(indexCount, this.state.indexCount),
            pagedCancelledUser: users.slice(indexCount, this.state.indexCount),
        });
        event.preventDefault();
    };

    handleCancelPreviousClick = (event) => {
        let users = [...this.state.cancelledUsers];
        let indexCount = this.state.indexCount - this.state.paginationCount;
        this.setState({
            indexCount: this.state.indexCount - this.state.paginationCount,
            pagedCancelledUser: users.slice(indexCount, this.state.indexCount),
        });
        event.preventDefault();
    };

    callCancelledUsers = (param) => {

        if(param === "enable") {

            let pagedCancelUserList = [...this.state.cancelledUsers];
            if(pagedCancelUserList.length > this.state.paginationCount) pagedCancelUserList = pagedCancelUserList.slice(0, this.state.paginationCount);

            this.setState({
                enableCancelledUsers: true,
                pagedCancelledUser: pagedCancelUserList,
                indexCount: 0
            });
        }
        else {
            let pagedUserList = [...this.state.users];
            if(pagedUserList.length > this.state.paginationCount) pagedUserList = pagedUserList.slice(0, this.state.paginationCount);

            this.setState({
                enableCancelledUsers: false,
                pagedUserList: pagedUserList,
                indexCount: 0
            });
        }
    };

    deleteCancelledUser = () => {
        this.setState({
            isAction: true
        });

        userService.deleteCancelUser(this.state.userId).then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Failed to delete Member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            if(resp.data.error) {
                this.setState({
                    message: "Failed to delete Member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }

            this.setState({
                isAction: false,
                message: "Member deleted successfully",
                msgType: "success"
            });
            this.getAllUsers();
        });

    };

    reactivateUser = (user) => {
        this.setState({
            isAction: true
        });
        $(".confirm_reactivate").removeClass("active");
        userService.reactivateCancelledUser(this.state.reactivateId).then(resp => {
            if(resp === false) {
                this.setState({
                    message: "Failed to reactive member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }
            if(resp.data.error) {
                this.setState({
                    message: "Failed to reactivate member, Try again!",
                    msgType: "error",
                    isAction: false
                });
                return;
            }

            this.setState({
                isAction: false,
                message: "User has been reactivated sucessfully",
                msgType: "success"
            });
            $("body").removeClass("popup_no_scroll");
            this.getAllUsers();


        });
    };

    render() {
        //console.log("user component")

        if(localStorage.getItem("roleId") === "1") {
            return <Redirect to="/error"></Redirect>;
        }
        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }

        const cssResend = ".st0{fill:#4C8CCD;}";


        return (
            <body className="main_nav_module users_main_module">
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'users' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            { this.state.enableCancelledUsers ?
                                <div className="header_wrap_bottom">
                                    <div className="bottom_navbar">
                                        <div className="bn_left">
                                            <div className="computer_no">
                                                <span className="bck_icon" data-for="backUsers" data-tip onClick={ () => this.callCancelledUsers("disable") }>
                                                    <span className="svg_wrap">➔</span>
                                                </span><ReactToolTip id="backUsers" effect='solid' place='right' backgroundColor='black' multiline={ true }>Back to Users list page</ReactToolTip>
                                                <span className="text bold_600">Canceled Users</span>
                                            </div>
                                        </div>
                                        <div className="bn_right">
                                            <div className="rhs_info" style={ { display: this.state.cancelledUsers.length <= 0 ? "none" : "" } }>
                                                <p>Number of canceled users: { this.state.cancelledUsers.length < 10 ? '0' + this.state.cancelledUsers.length : this.state.cancelledUsers.length }</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="header_wrap_bottom">
                                    <div className="bottom_navbar">
                                        <div className="bn_left">
                                            <div className="computer_no">
                                                <span className="text bold_600">Users</span>

                                            </div>
                                        </div>
                                        <div className="bn_right">
                                            <div className="rhs_info" style={ { display: this.state.userCount <= 0 ? "none" : "" } }>
                                                <p>Number of users: { this.state.userCount < 10 ? '0' + this.state.userCount : this.state.userCount }</p>
                                            </div>
                                            <div className="divider"></div>

                                            <div className="rhs_cta">
                                                <div className="btn_wrap_icon" style={ { display: this.state.userCount <= 0 ? "none" : '' } }> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 25 25" enableBackground="new 0 0 25 25" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M23.5,22c-0.8-5-3.6-8-7.3-9.3c1.7-1.4,2.7-3.6,2.1-6.1  c-0.5-2.2-2.3-3.9-4.5-4.4C9.9,1.3,6.5,4.3,6.5,8c0,1.9,0.9,3.6,2.3,4.7C5.1,14,1.7,17.5,1.5,22c-0.1,1.2,1.6,1,1,1h20  C23.7,23,23.5,22.1,23.5,22z M16.5,8c0-2.2-1.8-4-4-4s-4,1.8-4,4s1.8,4,4,4S16.5,10.2,16.5,8z M12.5,14c-4.3,0-7.9,3-8.8,7h17.5  C20.4,17,16.8,14,12.5,14z"></path>
                                                </svg></span>
                                                    <input type="button" name="" value="Add User" className="common_cta_btn blue add_usr_cta" onClick={ this.enableAddUser }></input>
                                                </div>
                                                <div className="btn_wrap_icon viewCanceluser_btn" onClick={ () => this.callCancelledUsers("enable") }>
                                                    <button type="button" data-for='cancelTitle' data-tip name="" className="common_cta_btn blue cancelled_usr_cta" >
                                                        <span className="svg_wrap" data-for='cancelTitle' data-tip>
                                                            <svg x="0px" y="0px" viewBox="0 0 18 18" style={ { enableBackground: "new 0 0 18 18" } } xmlSpace="preserve">
                                                                <g>
                                                                    <circle className="cu0" cx="7.8" cy="4.4" r="3.4" />
                                                                    <path className="cu1" d="M11.7,9c-1.1-0.7-2.4-1.2-3.9-1.2c-3.8,0-7,3.1-7,7h5.8" />
                                                                </g>
                                                                <g>
                                                                    <path className="cu0" d="M17.2,13.3c-0.7,1.6-2.3,2.7-4.1,2.7c-1.8,0-3.4-1.1-4.1-2.7c0.7-1.6,2.3-2.6,4.1-2.6
                                                                    C14.9,10.7,16.5,11.8,17.2,13.3z"/>
                                                                    <circle className="cu2" cx="13.1" cy="13.3" r="1" />
                                                                </g>
                                                            </svg>
                                                        </span><ReactToolTip id="cancelTitle" effect='solid' place='left' backgroundColor='black' multiline={ true }>View Canceled<br></br> Users</ReactToolTip>

                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }


                        </header>
                        <NotificationSlider />
                        <section className="main_section pagination__wrap">
                            <div className="main_body_container">
                                <div className="user_container">
                                    { this.state.enableCancelledUsers ?
                                        <div className="cancelledUser_table">
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1" onClick={ (event) => { this.headerSortClick(event); this.setSortingForCancelUser("mail"); } }>
                                                                <div className="header_sort_wrap">Email Address<span className="sort_icon active"
                                                                ></span></div>
                                                            </div>
                                                            <div className="col col2" onClick={ (event) => { this.headerSortClick(event); this.setSortingForCancelUser("fname"); } }>
                                                                <div className="header_sort_wrap">Name<span className="sort_icon"
                                                                ></span></div>
                                                            </div>

                                                            <div className="col col3">
                                                                <span>Reactivate</span>
                                                            </div>
                                                            <div className="col col4">Actions</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">

                                                    <ul style={ { display: this.state.cancelledUsers.length <= 0 ? "block" : "none" } }>
                                                        <li>
                                                            <div className="outer_empty_wrap fullPageEmpty">
                                                                <div className="inner_empty_wrap">
                                                                    <div className="svg_wrap empty_icon usersCreate_empty"></div>
                                                                    <p className="empty_title">No entries found in the canceled users list.</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                    <ul style={ { display: this.state.cancelledUsers.length > 0 ? "block" : "none" } }>
                                                        { this.state.pagedCancelledUser.map((user, i) =>

                                                            <li className="tr">
                                                                <div className="col col1">
                                                                    <div className="name_icon"><span className="svg_wrap">{ user.email.charAt(0).toUpperCase() }</span></div>
                                                                    <span className="name_txt" data-for={ user.email } data-tip>{ user.email }</span>
                                                                    <ReactToolTip id={ user.email } effect="solid" place='top'>{ user.email }</ReactToolTip>
                                                                </div>
                                                                <div className="col col2" >
                                                                    <span data-tip data-for={ user.name }>{ user.name }</span>
                                                                    { user.name !== "----" ? <ReactToolTip id={ user.name } effect="solid" place="top"><span className="u_name">{ user.name }</span></ReactToolTip> : "" }
                                                                </div>
                                                                <div className="col col3">
                                                                    <button type="button" className={ localStorage.getItem("status") === 'S' ? "reactivateBtn disabled" : "reactivateBtn" } onClick={ () => this.enableUserReactivate(user) } disabled={ localStorage.getItem("status") === 'S' }>Reactivate</button>
                                                                </div>
                                                                <div className="col col4" onClick={ () => { this.enableDeleteUser([user.id, user.email, user.status, "cancel"]); } }>
                                                                    <a className="delete" data-for='cancelDelete' data-tip>
                                                                        <span className="icon">
                                                                            <span className="svg_wrap">
                                                                                <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                    <path fillRule="evenodd" clipRule="evenodd" className="dl0" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                    <ReactToolTip id="cancelDelete" place="top" effect="solid">Delete</ReactToolTip>
                                                                </div>
                                                            </li>
                                                        ) }
                                                    </ul>
                                                </div>
                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.cancelledUsers.length > this.state.paginationCount ? '' : 'none' } }>
                                                    <div className="Page_navigation">
                                                        <ul className="pagination_ul">
                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handleCancelPreviousClick(event); } }>
                                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                                    <span aria-hidden="true">«</span>
                                                                    <span className="sr-only">Previous</span>
                                                                </a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.paginationCount) > this.state.cancelledUsers.length ? this.state.cancelledUsers.length : (this.state.indexCount + this.state.paginationCount) }
                                                                </a>
                                                            </li>
                                                            <li className={ this.state.indexCount + this.state.paginationCount > this.state.cancelledUsers.length - 1 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleCancelNextClick(event); } }>
                                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                    <span aria-hidden="true">»</span>
                                                                    <span className="sr-only">Next</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="userMain_table">
                                            <div className="tabular_data_wrap twofa_usersTable">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["mail"]); } }>Email Address<span className="sort_icon active" ></span></div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["name"]); } }>Name<span className="sort_icon" ></span></div>
                                                            </div>

                                                            <div className="col col3">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["date"]); } }>Created On<span className="sort_icon" ></span></div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap" >Role</div>
                                                            </div>
                                                            <div className="col col5">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["status"]); } }>Status<span className="sort_icon" ></span></div>
                                                            </div>
                                                            <div className="col col6">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["2fa"]); } }>2FA Status<span className="sort_icon"></span></div>
                                                            </div>
                                                            <div className="col col7"> Actions </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    { this.state.userCount === 0 && !this.state.isAction ?
                                                        <ul>
                                                            <li>
                                                                <div className="outer_empty_wrap fullPageEmpty">
                                                                    <div className="inner_empty_wrap">
                                                                        <div className="svg_wrap empty_icon usersCreate_empty"></div>
                                                                        <p className="empty_head">Users</p>
                                                                        <p className="empty_title">Add users to your account by sending an activation link. The newly registered users can access your account and use the linked instances and other resources.</p>
                                                                        <div className="btn_wrap_icon btnDefaultPad"> <input type="button" value="Add Users" className="common_cta_btn blue" onClick={ this.enableAddUser }></input></div>

                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        :
                                                        <ul>
                                                            { this.state.pagedUserList.map((user, i) =>
                                                                <li className="tr" key={ i }>
                                                                    <div className="col col1" >
                                                                        <div className="name_icon"><span className="svg_wrap">{ user.email.charAt(0).toUpperCase() }</span></div><span data-tip data-for={ user.email }>{ user.email }</span>
                                                                    </div><ReactToolTip id={ user.email } effect="solid" place="top">{ user.email }</ReactToolTip>
                                                                    <div className="col col2" >
                                                                        <span data-tip data-for={ user.name }>{ user.name }</span>
                                                                        { user.name !== "----" ? <ReactToolTip id={ user.name } effect="solid" place="top"><span className="u_name">{ user.name }</span></ReactToolTip> : "" }
                                                                    </div>

                                                                    <div className="col col3">{ user.createdOn }</div>
                                                                    <div className="col col4">{ user.role }</div>
                                                                    <div className="col col5">{ user.status }</div>
                                                                    <div className={ "col col6 " + user.authClass } >{ user.authStatus }</div>
                                                                    <div className="col col7"><span className="menu_icon" onClick={ (e) => this.enableUserOptions(e, user.username) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                    </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                        <ul className="dropdown_component users_row_options">
                                                                            <span className="arrow_pointer"></span>
                                                                            { user.status === "Invited" ?
                                                                                <li className="edit" onClick={ () => { this.enableEditUser([user.email, user.id, user.firstname, user.lastname]); } }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                                                                </svg></span></span>Edit User</li>
                                                                                : "" }
                                                                            { user.status === "Invited" ?
                                                                                <li className={ this.state.disableResendBtn ? "resend disabled" : "resend" } style={ { display: this.state.disableResendBtn ? "none" : "" } } onClick={ (e) => { this.resendActivationEmail(e, user); } }><span className="icon"> <span className="svg_wrap"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 19" enableBackground="new 0 0 21 19;" xmlSpace="preserve">
                                                                                    <style type="text/css">
                                                                                        { cssResend }
                                                                                    </style>
                                                                                    <path className="st0" d="M18.9,10.9C16.4,7.5,12.4,6,10,5.4V2c0-0.3-0.1-0.5-0.3-0.7c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1
                                                                                      C9,0.9,8.6,1,8.3,1.3L1.9,8L1.2,8.8c-0.4,0.4-0.4,1,0,1.4L1.9,11l6.3,6.7C8.5,17.9,8.7,18,9,18c0.3,0,0.5-0.1,0.7-0.3
                                                                                      C9.9,17.5,10,17.3,10,17v-3.5c6-0.6,8.1,2,8.2,2.1c0.2,0.3,0.5,0.4,0.8,0.4c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.5,0.7-1l0-0.7
                                                                                      C20,13.1,19.6,11.9,18.9,10.9z M11.7,11.4c-0.4,0-1,0-1.7,0.1c-0.7,0.1-1.4,0.2-2,0.3v2.6l-0.5-0.6l-1.4-1.5L3.3,9.5l4.7-5V7
                                                                                      c0.5,0.1,1.2,0.3,2,0.5c2.5,0.8,6,2.4,7.7,5.2C16.5,12.1,14.5,11.4,11.7,11.4z"></path>
                                                                                </svg></span></span>Resend Invite</li>
                                                                                : "" }
                                                                            { this.state.adminStatus === "ENABLED" && user.authStatus === "2FA Disabled" ?
                                                                                <li className="enable2fa" onClick={ () => { this.setState({ isEnablePopUp: true, currentUser: user }); setTimeout(() => { document.getElementById("enablepopupfocus").focus(); }, 100); } }>
                                                                                    <span className="icon">
                                                                                        <span className="svg_wrap">
                                                                                            <svg x="0px" y="0px" viewBox="0 0 20 20" style={ { enablebackground: "new 0 0 20 20" } } xmlSpace="preserve">
                                                                                                <path className="en0" d="M10,0.5c-5.3,0-9.5,4.3-9.5,9.5c0,5.3,4.3,9.5,9.5,9.5c5.3,0,9.5-4.3,9.5-9.5C19.5,4.7,15.3,0.5,10,0.5z
                                                               M10,17.5c-4.2,0-7.5-3.4-7.5-7.5c0-4.2,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5C17.5,14.1,14.1,17.5,10,17.5z M8.8,10.6L7,8.8l-1.4,1.4
                                                              l2.5,2.5l0.7,0.7l5.7-5.7L13,6.4L8.8,10.6z"></path>
                                                                                            </svg>
                                                                                        </span></span>Enable 2FA</li>
                                                                                : "" }
                                                                            { this.state.adminStatus === "ENABLED" && user.authStatus !== "2FA Disabled" ?
                                                                                <li className="disable2fa" onClick={ () => { this.setState({ isDisablePopUp: true, currentUser: user }); setTimeout(() => { document.getElementById("disablepopupfocus").focus(); }, 100); } }>
                                                                                    <span className="icon">
                                                                                        <span className="svg_wrap">
                                                                                            <svg x="0px" y="0px" width="7px" height="7px" viewBox="0 0 7 7" enableBackground="new 0 0 7 7" xmlSpace="preserve">
                                                                                                <path fill="#4C8CCA" d="M6.732,3.5c0,1.787-1.445,3.232-3.232,3.232c-1.787,0-3.232-1.445-3.232-3.232S1.713,0.268,3.5,0.268
                                                             C5.287,0.268,6.732,1.713,6.732,3.5z M3.5,5.972c0.533,0,1.064-0.19,1.445-0.494l-3.46-3.461C1.181,2.436,0.991,3.12,0.991,3.462
                                                             C1.029,5.174,2.131,5.972,3.5,5.972z M2.017,1.522l3.46,3.46C5.781,4.564,5.973,4.07,5.973,3.538c0-1.369-0.799-2.472-2.473-2.472
                                                             C3.12,1.028,2.436,1.219,2.017,1.522z"></path>
                                                                                            </svg>
                                                                                        </span>
                                                                                    </span>Disable 2FA</li>
                                                                                : "" }
                                                                            { this.state.adminStatus === "ENABLED" && user.authStatus === "Configured" ?
                                                                                <li className="reset2fa" onClick={ () => { this.do2faoperation(user, "RESET"); } }>
                                                                                    <span className="icon">
                                                                                        <span className="svg_wrap">
                                                                                            <svg version="1.1" x="0px" y="0px" viewBox="0 0 10 10" style={ { enableBackground: "new 0 0 10 10" } } xmlSpace="preserve">

                                                                                                <g>
                                                                                                    <path fill="#518FCC" d="M7.7,9.7H2.3c-0.9,0-1.5-0.3-1.5-1.5v-3c0-0.8,0.2-1.5,1.5-1.5l0,0V3c0-1.5,1.2-2.7,2.7-2.7S7.7,1.5,7.7,3v0.7
                                                        c1,0,1.5,0.5,1.5,1.5v3C9.2,9.2,8.7,9.7,7.7,9.7z M6.7,3c0-0.9-0.8-1.7-1.7-1.7S3.3,2.1,3.3,3v0.7h3.4V3z M8.2,5.7c0-0.7-0.1-1-1-1
                                                        H2.8c-0.9,0-1,0.2-1,1v2c0,0.7,0.1,1,1,1h4.4c0.9,0,1-0.1,1-1V5.7z"></path>
                                                                                                    <g>
                                                                                                        <path fill="#518FCC" d="M3.8,6.1L3.3,6.6l0,0L4,6.5v0.4L3.3,6.8l0,0l0.4,0.5L3.4,7.4L3.2,6.9l0,0L2.9,7.4L2.6,7.3L3,6.8l0,0L2.4,6.9
                                                        V6.5L3,6.6l0,0L2.6,6.1l0.3-0.2l0.2,0.6l0,0l0.2-0.6L3.8,6.1z"></path>
                                                                                                        <path fill="#518FCC" d="M5.5,6.1L5.1,6.6l0,0l0.6-0.1v0.4L5.1,6.8l0,0l0.4,0.5L5.2,7.4L4.9,6.9l0,0L4.7,7.4L4.3,7.3l0.4-0.5l0,0
                                                        L4.2,6.9V6.5l0.6,0.1l0,0L4.3,6.1l0.3-0.2l0.2,0.6l0,0l0.2-0.6L5.5,6.1z"></path>
                                                                                                        <path fill="#518FCC" d="M7.4,6.1L6.9,6.6l0,0l0.6-0.1v0.4L6.9,6.8l0,0l0.4,0.5L7,7.4L6.8,6.9l0,0L6.5,7.4L6.2,7.3l0.4-0.5l0,0L6,6.9
                                                        V6.5l0.6,0.1l0,0L6.2,6.1l0.3-0.2l0.2,0.6l0,0L7,5.9L7.4,6.1z"></path>
                                                                                                    </g>
                                                                                                </g>
                                                                                            </svg>


                                                                                        </span>
                                                                                    </span>Reset 2FA</li>
                                                                                : "" }


                                                                            <li className="delete" onClick={ () => { this.enableDeleteUser([user.id, user.email, user.status, "notcancel"]); } }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                            </svg></span></span>Delete User</li>
                                                                        </ul>
                                                                    </span></div>
                                                                </li>
                                                            ) }

                                                        </ul>

                                                    }
                                                </div>
                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.users.length > this.state.paginationCount ? '' : 'none' } }>
                                                    <div className="Page_navigation">
                                                        <ul className="pagination_ul">
                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                                    <span aria-hidden="true">«</span>
                                                                    <span className="sr-only">Previous</span>
                                                                </a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.paginationCount) > this.state.users.length ? this.state.users.length : (this.state.indexCount + this.state.paginationCount) }
                                                                </a>
                                                            </li>
                                                            <li className={ this.state.indexCount + this.state.paginationCount > this.state.users.length - 1 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                    <span aria-hidden="true">»</span>
                                                                    <span className="sr-only">Next</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </section>
                        {/* Edit User Options */ }
                        <div className="main_slider usr_rhs_slider edit_user_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-tip data-for="editclose" onClick={ () => { this.closeslider("editslider"); } }></div><ReactToolTip id="editclose" effect="solid" place='left'>
                                        Close
                                    </ReactToolTip>

                                    <div className="usr_rhs_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                <path fill="#FFFFFF" d="M477.8,454.9c-4.6,7.8-12.8,13.3-22.5,13.3H57.4c-9.7,0-17.9-5.5-22.5-13.3c0,0-4.1-6-2.1-22.8  c9.5-89.2,73.1-149.2,158.9-168.9C158.8,241.8,137,205.1,137,163c0-65.9,53.5-119.4,119.4-119.4S375.8,97.1,375.8,163  c0,42-21.8,78.8-54.7,100.1c85.7,19.7,149.4,79.7,158.8,168.9C483,444.7,477.8,454.9,477.8,454.9z" />
                                            </svg></span> </span>Edit User</h2>
                                        </div>
                                        <div className="usrRhs_content_wrap">
                                            <p className="info_txt" style={ { display: "none" } }>Update the name and email address of the user</p>
                                            <div className="common_txtBox_row">
                                                <label>First Name</label>
                                                <input type="text" ref={ this.editfirstnameinput } minLength="4" maxLength="20" autoFocus name="editFirstName" value={ this.state.editFirstName } className="txt_box" onChange={ this.handleInputs } ></input>
                                                <span className="err_msg" style={ { display: this.state.firstNameRegex ? 'inline-block' : 'none', color: "red" } }>First name can contain a-z, A-Z and space</span>
                                                <span className="err_msg" style={ { display: this.state.editfirstnameempty ? 'inline-block' : 'none', color: "red" } }>First name cannot be blank</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Last Name</label>
                                                <input type="text" ref={ this.editlastnameinput } minLength="4" maxLength="20" name="editLastName" value={ this.state.editLastName } onClick={ (e) => this.getEditFocus("lastname") } onFocus={ (e) => this.getEditFocus("lastname") } className="txt_box" onChange={ this.handleInputs } ></input>
                                                <span className="err_msg" style={ { display: this.state.lastNameRegex ? 'inline-block' : 'none', color: "red" } }>Last Name can contain a-z, A-Z and space</span>
                                                <span className="err_msg" style={ { display: this.state.editlastnameempty ? 'inline-block' : 'none', color: "red" } }>Last name cannot be blank</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Email Address</label>
                                                <input type="text" ref={ this.editemailinput } name="email" value={ this.state.email } className="txt_box email_field" onClick={ (e) => this.getEditFocus("email") } onFocus={ (e) => this.getEditFocus("email") } onChange={ this.handleInputs } disabled></input>
                                                <span className="err_msg" style={ { display: this.state.emailRegex ? 'inline-block' : 'none', color: "red" } }>Email is invalid</span>
                                                <span className="err_msg" style={ { display: this.state.editemailempty ? 'inline-block' : 'none', color: "red" } }>Email cannot be blank</span>
                                                <input type="button" name="" value="Save Changes" className={ this.state.getEditButton ? "common_cta_btn blue email_save_cta" : "common_cta_btn blue email_save_cta disabled" } onClick={ this.editUser } disabled={ !this.state.getEditButton }></input>
                                                <input type="button" name="" value="Cancel" style={ { marginTop: "28px", marginLeft: "10px" } } className="common_cta_btn transparentGrey" onClick={ () => { this.closeslider("editslider"); } }></input>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of User Options */ }
                        {/*Add User */ }
                        <div className="main_slider usr_rhs_slider add_user_slider" onKeyPress={ (e) => this.enterPressed(e, "add") }>
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-tip data-for="close" onClick={ () => { this.closeslider("addslider"); } }></div><ReactToolTip id="close" effect="solid" place="left">
                                        close
                                    </ReactToolTip>
                                    <div className="usr_rhs_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                <path fill="#FFFFFF" d="M477.8,454.9c-4.6,7.8-12.8,13.3-22.5,13.3H57.4c-9.7,0-17.9-5.5-22.5-13.3c0,0-4.1-6-2.1-22.8  c9.5-89.2,73.1-149.2,158.9-168.9C158.8,241.8,137,205.1,137,163c0-65.9,53.5-119.4,119.4-119.4S375.8,97.1,375.8,163  c0,42-21.8,78.8-54.7,100.1c85.7,19.7,149.4,79.7,158.8,168.9C483,444.7,477.8,454.9,477.8,454.9z" />
                                            </svg></span> </span>Add User</h2>
                                        </div>
                                        <div className="usrRhs_content_wrap">
                                            <p className="info_txt">Invite users to your account. The users will be able to add and access resources; you can manage the billing centrally.</p>
                                            <div className="common_txtBox_row">
                                                <label>Email Address</label>
                                                <input type="text" placeholder="Enter email address of the user" value={ this.state.addemail } onClick={ (e) => this.getEditFocus("addemail") } onFocus={ (e) => this.getEditFocus("addemail") } ref={ this.emailInput } name="addemail" className="txt_box" onChange={ this.handleInputs } autoComplete="chrome-off"></input>
                                                <span className="err_msg" style={ { display: this.state.emailRegex ? 'inline-block' : 'none', color: "red" } }>Email address is invalid</span>
                                                <span className="err_msg" style={ { display: this.state.addemailempty ? 'inline-block' : 'none', color: "red" } }>Email cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.usernameexists ? 'inline-block' : 'none', color: "red" } }>Email already in use</span>
                                            </div>
                                            <div className="common_txtBox_row enable2fa" style={ { display: this.state.adminStatus === "ENABLED" ? "none" : "none" } }>
                                                <label className="checkBox">
                                                    <input type="checkbox" id="enableCheckBox" onClick={ (e) => this.enableCheckBox(e) } />
                                                    <span className="checkmark"></span>
                                                    <p className="add_on_head">Enable two-step verification</p>
                                                </label>
                                                <span className="question_icon" data-tip data-for="2fatool" data-toggle="tooltip" data-placement="top" title="" data-original-title="">
                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="14px">?</text>
                                                    </svg>
                                                </span>
                                                <ReactToolTip id="2fatool" place="top" effect="solid" multiline={ true } >
                                                    This provides an additional layer of protection by using a OTP, <br></br>sent to your registered email address or phone number,<br></br> to authenticate all sign in to your account. <br></br>Once enabled, user has to enter a one-time verification code sent to email address or phone number, <br></br>or generated via TOTP authenticator app in addition to password to sign in.
                                                </ReactToolTip>
                                                <small>This provides an additional layer of protection by using a OTP, sent to your registered email address or phone number, to authenticate all sign in to your account.</small>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Add User" className={ this.state.isAddUser ? "common_cta_btn blue disabled" : "common_cta_btn blue" } onClick={ this.addUser } disabled={ this.state.isAddUser }></input>
                                                <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => { this.closeslider("addslider"); } }></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of Add User*/ }
                        {/*Delete User*/ }
                        <div className="main_popup delete_user_popup">
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.closeslider("delete"); } }></span>
                                        <div className="popup_header">
                                            <div className="sub_title"> Delete User</div>
                                        </div>

                                        <div className="popup_body">
                                            <p>Are you sure you want to delete the user <b>{ this.state.deleteEmail }</b>?</p>
                                            <p style={ { display: this.state.deleteUserStatus === "Active" ? "block" : "none" } }>You can reactivate a user account from the 'View Canceled Users' section.</p>
                                        </div>

                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => { this.closeslider("delete"); } }>Cancel</button>
                                                <button className="btn btn_confirm" id="deleteUser" onClick={ this.deleteUser }>Delete</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of delete user */ }
                        {/*Delete User*/ }
                        <div class="main_popup delete_cancelled_user_popup">
                            <div class="main_popup_wrapper">
                                <div class="main_popup_bg_shadow"></div>
                                <div class="main_popup__inner">
                                    <div class="popup_wrap">  <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.closeslider("delete"); } }></span>
                                        <div class="popup_header">
                                            <div class="sub_title"> Delete User</div>
                                        </div>
                                        <div class="popup_body">
                                            <p>This will delete the user permanently from your account and it is an irreversible process.</p>
                                            <p>Are you sure you want to delete the user <b>{ this.state.deleteEmail }</b>?</p>
                                        </div>
                                        <div class="popup_footer">
                                            <div class="popup_footer__btns">
                                                <button className="btn btn_cancel" onClick={ () => { this.closeslider("delete"); } }>Cancel</button>
                                                <button className="btn btn_confirm" id="deleteUser" onClick={ this.deleteUser }>Delete</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of delete user */ }
                        {/*Delete User*/ }
                        <div class="main_popup confirm_reactivate">
                            <div class="main_popup_wrapper">
                                <div class="main_popup_bg_shadow"></div>
                                <div class="main_popup__inner">
                                    <div class="popup_wrap">  <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.closeslider("reactivate"); } }></span>
                                        <div class="popup_header">
                                            <div class="sub_title"> Reactivate</div>
                                        </div>
                                        <div class="popup_body">
                                            <p>Are you sure you want to reactivate the user <b>{ this.state.reactivateEmail }</b>?</p>
                                        </div>
                                        <div class="popup_footer">
                                            <div class="popup_footer__btns">
                                                <button className="btn btn_cancel" onClick={ () => { this.closeslider("reactivate"); } }>Cancel</button>
                                                <button className="btn blue" id="reactivateUser" onClick={ this.reactivateUser } >Reactivate</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of delete user */ }
                        <div className={ this.state.isEnablePopUp ? "main_popup enable2faPopup active" : "main_popup enable2faPopup" }>
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.setState({ isEnablePopUp: false }); } }></span>
                                        <div className="popup_header">
                                            <div className="sub_title">Enable two-factor authentication</div>
                                        </div>
                                        <div className="popup_body">
                                            <p>Once enabled, user has to enter a one-time verification code sent to email address or phone number, or generated via TOTP authenticator app in addition to password to sign in.</p>
                                            <p>Do you want to proceed?</p>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => { this.setState({ isEnablePopUp: false }); } }>Cancel</button>
                                                <button className="btn blue" id="enablepopupfocus" onClick={ () => { this.do2faoperation(this.state.currentUser, "ENABLE"); } }>Enable</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={ this.state.isDisablePopUp ? "main_popup disable2faPopup active" : "main_popup disable2faPopup" }>
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.setState({ isDisablePopUp: false }); } }></span>
                                        <div className="popup_header">
                                            <div className="sub_title">Disable two-factor authentication</div>
                                        </div>
                                        <div className="popup_body">
                                            <p>This will disable two-factor authentication used to validate all sign in to the user account.</p>
                                            <p>Do you want to proceed?</p>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn btn_cancel" onClick={ () => { this.setState({ isDisablePopUp: false }); } }>Cancel</button>
                                                <button className="btn blue" id="disablepopupfocus" onClick={ () => { this.do2faoperation(this.state.currentUser, "DISABLE"); } }>Disable</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </body>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
export default User;